const activeItems = (state = [], action) => {
	switch (action.type) {
		case "INITIAL_NOTIFICATIONS_RECEIVED": {
			const ids = [];
			action.notifications.forEach((item) => {
				if (item) {
					ids.push(item.id);
				}
			});
			const newState = [...ids];
			return newState;
		}

		case "NOTIFICATION_BATCH_RECEIVED": {
			const newState = [...state];
			action.notifications.forEach((item) => {
				if (item) {
					if (item.remove) {
						const idx = newState.indexOf(item.id);
						if (idx > -1) newState.splice(idx, 1);
					} else {
						if (!newState.includes(item.id)) newState.push(item.id);
					}
				}
			});
			return newState;
		}

		default:
			return state;
	}
};

const activeItemsById = (state = {}, action) => {
	switch (action.type) {
		case "INITIAL_NOTIFICATIONS_RECEIVED": {
			return action.notifications.reduce((acc, not) => {
				if (not) {
					return { ...acc, [not.id]: not };
				} else {
					return { ...acc };
				}
			}, {});
		}

		case "NOTIFICATION_BATCH_RECEIVED": {
			{
				const not = action.notifications.reduce((acc, not) => {
					if (not) {
						return { ...acc, [not.id]: not };
					} else {
						return { ...acc };
					}
				}, {});
				const updatedState = { ...state, ...not };
				const finalState = Object.fromEntries(
					Object.entries(updatedState).filter(([key, value]) => !value.remove)
				);
				return finalState;
			}
		}

		default:
			return state;
	}
};

export const initialState = {
	initial: false,
	activeItems: [],
	activeItemsById: {}
};

const notifications = (state = initialState, action) => {
	switch (action.type) {
		case "INITIAL_NOTIFICATIONS_RECEIVED":
			return {
				...state,
				initial: true,
				activeItems: activeItems(state.activeItems, action),
				activeItemsById: activeItemsById(state.activeItemsById, action)
			};
		case "NOTIFICATION_BATCH_RECEIVED":
			return {
				...state,
				initial: false,
				activeItems: activeItems(state.activeItems, action),
				activeItemsById: activeItemsById(state.activeItemsById, action)
			};
		default:
			return state;
	}
};

export default notifications;
